module.exports = __webpack_public_path__ + "assets/img/btn-detail-ca14d642.png";